module.exports = __webpack_public_path__ + "img/setting_color.a02510e9.svg";